"use client";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
// import { Button } from "../ui/button";
import { useCallback, useState } from "react";
// import { GoogleIcon } from "@/icons/google-icon";
import FormSignUp from "./form-sign-up";
import { useAuthDialogStore } from "@/hooks/use-auth-dialog";

export const SignUpDialog = () => {
  const { signIn, signUp, } =
    useAuthDialogStore();

  const [showOtp, setShowOtp] = useState(false);
  // const handleGoogleLogin = useCallback(() => {
  //   window.location.href = "/api/auth/callback/google";
  // }, []);
  return (
    <Dialog open={signUp.open} onOpenChange={signUp.setOpen}>
      <DialogContent className="sm:max-w-[560px] !p-0 gap-0">
        <DialogHeader className="px-6 py-5 border-b">
          <DialogTitle>Бүртгүүлэх</DialogTitle>
        </DialogHeader>
        <div className="px-4 py-5">
          <FormSignUp setShowOtp={setShowOtp} showOtp={showOtp} />
        </div>
        {!showOtp && (
          <>
            {" "}
            <div className="flex w-full items-center gap-3">
              <div className="h-[1px] w-full bg-gray-200" />
              <p className="font-semibold text-gray-500">OR</p>
              <div className="h-[1px] w-full bg-gray-200" />
            </div>
            <div className="space-y-4 p-4">
              {/* <Button
                className="w-full rounded-lg border border-[#D0D5DD] bg-[#FFF] text-black shadow-[0px_1px_2px_rgba(16,24,40,0.05)]"
                variant={"outline"}
                onClick={handleGoogleLogin}
              >
                <GoogleIcon /> Continue with Google
              </Button> */}
              <div className="text-center w-full flex justify-center gap-1">
                Already have an account?{" "}
                <p
                  className="font-semibold px-0 cursor-pointer"
                  onClick={() => {
                    signUp.closeDialog();
                    signIn.openDialog();
                  }}
                >
                  Sign in
                </p>
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
